var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCotranscat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_cotranscat",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.012,
    height: 32,
    viewBox: "0 0 47.012 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_191",
    "data-name": "Rectangle 191",
    width: 47.012,
    height: 32,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M147.789,58.994l-6.394,9.073h12.271Z",
    transform: "translate(-106.652 -44.409)",
    fill: "#45783c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M152.7,67.394H140.708a.224.224,0,0,1-.183-.353l6.247-8.864a.213.213,0,0,1,.188-.1.225.225,0,0,1,.184.1l5.741,8.864a.224.224,0,0,1-.188.346m-11.556-.448h11.143l-5.336-8.24Z",
    transform: "translate(-105.907 -43.786)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 2.786,
    height: 2.326,
    transform: "translate(39.401 23.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M162.188,97.028H159.4a.224.224,0,0,1-.224-.224V94.478a.224.224,0,0,1,.224-.224h2.786a.224.224,0,0,1,.224.224V96.8a.224.224,0,0,1-.224.224m-2.562-.448h2.337V94.7h-2.337Z",
    transform: "translate(-120.001 -71.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M126.12,44.273s-1.365-1.393-5.234-1.477c-3.377,0-5.867,3.25-5.867,7.936,0,3.686,1.829,7.2,5.966,7.471,3.588,0,4.587-.844,5.621-1.393.591-.492,1.414,1.379.457,2.336-2.624,1.757-14.7,4.545-15.252-8.245,0-9.2,7.739-13.479,15.3-8.78.823.675-.3,2.681-.992,2.153",
    transform: "translate(-84.291 -30.302)",
    fill: "#ece452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M120.146,60.2a9.959,9.959,0,0,1-4.511-.989c-2.95-1.494-4.543-4.525-4.736-9.009,0-4.5,1.818-8.079,4.989-9.842,3.109-1.728,6.992-1.414,10.655.862l.024.017c.637.523.351,1.6-.1,2.168-.373.472-.821.6-1.17.337a.215.215,0,0,1-.024-.021c-.015-.015-1.371-1.33-5.08-1.411-3.265,0-5.638,3.243-5.638,7.711,0,3.172,1.507,6.973,5.756,7.248,3.084,0,4.213-.641,5.121-1.156.123-.07.243-.138.362-.2a.58.58,0,0,1,.816.128,2,2,0,0,1-.076,2.554.227.227,0,0,1-.034.028,13.05,13.05,0,0,1-6.355,1.576m.068-20.493a8.374,8.374,0,0,0-4.107,1.045c-3.024,1.681-4.759,5.122-4.759,9.44.185,4.3,1.7,7.2,4.49,8.618,3.867,1.959,8.91.431,10.394-.547a1.548,1.548,0,0,0,.047-1.919c-.13-.143-.187-.1-.217-.07a.238.238,0,0,1-.038.026c-.122.065-.244.134-.37.205-.953.541-2.14,1.214-5.356,1.214-4.573-.3-6.19-4.33-6.19-7.7,0-4.728,2.562-8.16,6.092-8.16,3.751.082,5.209,1.367,5.379,1.53.2.138.482-.2.537-.264.333-.422.558-1.205.178-1.535a11.623,11.623,0,0,0-6.08-1.888",
    transform: "translate(-83.605 -29.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M145.458,42.325a.225.225,0,0,1-.22-.179l-.549-2.659a.224.224,0,1,1,.439-.091l.549,2.659a.224.224,0,0,1-.174.265.222.222,0,0,1-.046,0",
    transform: "translate(-109.075 -29.565)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M136.617,44.473a.224.224,0,0,1-.2-.128l-1.14-2.406a.224.224,0,0,1,.405-.192l1.14,2.406a.224.224,0,0,1-.107.3.222.222,0,0,1-.1.022",
    transform: "translate(-101.964 -31.375)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M127.646,49.151a.224.224,0,0,1-.172-.08l-1.773-2.11a.224.224,0,1,1,.343-.288l1.773,2.11a.224.224,0,0,1-.172.368",
    transform: "translate(-94.724 -35.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M122.062,56.75a.221.221,0,0,1-.119-.034l-2.364-1.477a.224.224,0,1,1,.238-.38l2.364,1.477a.224.224,0,0,1-.119.414",
    transform: "translate(-90.069 -41.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M117.55,64.908a.226.226,0,0,1-.052-.006l-3-.718a.224.224,0,1,1,.1-.436l3,.717a.224.224,0,0,1-.052.443",
    transform: "translate(-86.19 -48.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M115.451,74.478h-.013l-2.955-.169a.224.224,0,0,1,.026-.448l2.955.169a.224.224,0,0,1-.013.448",
    transform: "translate(-84.639 -55.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M111.124,83.826a.224.224,0,0,1-.006-.448l3.081-.084a.224.224,0,0,1,.012.448l-3.081.084h-.006",
    transform: "translate(-83.605 -62.793)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M112.667,91.745a.224.224,0,0,1-.07-.437l2.955-.971a.224.224,0,0,1,.14.426l-2.955.971a.226.226,0,0,1-.07.011",
    transform: "translate(-84.768 -68.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M115.925,99.369a.224.224,0,0,1-.112-.418l2.7-1.562a.224.224,0,0,1,.224.388l-2.7,1.562a.226.226,0,0,1-.112.03",
    transform: "translate(-87.224 -73.396)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M121.757,106.99a.224.224,0,0,1-.154-.387l2.279-2.153a.224.224,0,1,1,.308.326l-2.279,2.153a.223.223,0,0,1-.154.061",
    transform: "translate(-91.621 -78.697)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M130.675,111.7a.224.224,0,0,1-.189-.344l1.52-2.406a.224.224,0,1,1,.379.239l-1.52,2.406a.224.224,0,0,1-.19.1",
    transform: "translate(-98.344 -82.058)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M141.823,114.744l-.03,0a.224.224,0,0,1-.192-.252l.338-2.533a.224.224,0,1,1,.444.059l-.338,2.533a.224.224,0,0,1-.222.195",
    transform: "translate(-106.748 -84.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M6.651,58.994,12.9,67.858H.911Z",
    transform: "translate(-0.687 -44.474)",
    fill: "#45783c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M12.213,67.394H.225a.224.224,0,0,1-.188-.346l5.741-8.864a.225.225,0,0,1,.184-.1.215.215,0,0,1,.188.1L12.4,67.041a.224.224,0,0,1-.183.353M.637,66.946H11.78l-5.807-8.24Z",
    transform: "translate(0 -43.786)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 2.786,
    height: 2.326,
    transform: "translate(4.825 23.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M21.7,97.028H18.918a.224.224,0,0,1-.224-.224V94.478a.224.224,0,0,1,.224-.224H21.7a.224.224,0,0,1,.224.224V96.8a.224.224,0,0,1-.224.224m-2.562-.448H21.48V94.7H19.142Z",
    transform: "translate(-14.093 -71.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M16.834,44.273S18.2,42.88,22.068,42.8c3.377,0,5.867,3.25,5.867,7.936,0,3.686-1.829,7.2-5.966,7.471-3.588,0-4.587-.844-5.621-1.393-.591-.492-1.414,1.379-.457,2.336,2.624,1.757,14.7,4.545,15.252-8.245,0-9.2-7.739-13.479-15.3-8.78-.823.675.3,2.681.992,2.153",
    transform: "translate(-11.65 -30.302)",
    fill: "#ece452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M21.434,60.2a13.045,13.045,0,0,1-6.355-1.576.205.205,0,0,1-.034-.028,1.813,1.813,0,0,1-.5-1.383,1.928,1.928,0,0,1,.425-1.171.58.58,0,0,1,.816-.128c.12.064.239.132.362.2.908.515,2.037,1.155,5.135,1.155,4.234-.274,5.742-4.075,5.742-7.247,0-4.468-2.373-7.711-5.643-7.711-3.705.081-5.061,1.4-5.075,1.411a.245.245,0,0,1-.024.021c-.349.264-.8.135-1.169-.337-.452-.573-.738-1.645-.1-2.168l.024-.017c3.663-2.276,7.546-2.59,10.655-.862,3.171,1.763,4.989,5.346,4.989,9.832-.192,4.493-1.786,7.524-4.736,9.018a9.967,9.967,0,0,1-4.511.989m-6.086-1.936c1.484.978,6.527,2.507,10.394.547,2.795-1.416,4.305-4.319,4.49-8.628,0-4.308-1.735-7.749-4.759-9.431-2.958-1.645-6.67-1.337-10.186.842-.381.329-.155,1.112.178,1.535.054.069.333.4.537.264.17-.163,1.628-1.448,5.374-1.53,3.535,0,6.1,3.431,6.1,8.16,0,3.366-1.618,7.4-6.176,7.7h0c-3.229,0-4.414-.673-5.368-1.213-.126-.071-.248-.14-.37-.205a.241.241,0,0,1-.039-.026c-.03-.025-.087-.073-.217.07a1.548,1.548,0,0,0,.047,1.919m.8-14.7h0Z",
    transform: "translate(-10.963 -29.598)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M42.5,42.325a.222.222,0,0,1-.046,0,.224.224,0,0,1-.174-.265l.549-2.659a.224.224,0,1,1,.439.091l-.549,2.659a.225.225,0,0,1-.22.179",
    transform: "translate(-31.871 -29.565)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M49.531,44.474a.222.222,0,0,1-.1-.022.224.224,0,0,1-.107-.3l1.14-2.406a.224.224,0,0,1,.405.192l-1.14,2.406a.224.224,0,0,1-.2.128",
    transform: "translate(-37.172 -31.376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M56.563,49.151a.224.224,0,0,1-.172-.368l1.773-2.11a.224.224,0,1,1,.343.288l-1.773,2.11a.224.224,0,0,1-.172.08",
    transform: "translate(-42.473 -35.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M60.336,56.75a.224.224,0,0,1-.119-.414l2.364-1.477a.224.224,0,1,1,.238.38l-2.364,1.477a.223.223,0,0,1-.119.034",
    transform: "translate(-45.317 -41.331)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M62.909,64.908a.224.224,0,0,1-.052-.443l3-.717a.224.224,0,1,1,.1.436l-3,.718a.226.226,0,0,1-.052.006",
    transform: "translate(-47.257 -48.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M65.139,74.478a.224.224,0,0,1-.013-.448l2.955-.169a.224.224,0,0,1,.026.448l-2.955.169h-.013",
    transform: "translate(-48.938 -55.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M69.077,83.826h-.006l-3.081-.084A.224.224,0,0,1,66,83.293l3.081.084a.224.224,0,0,1-.006.448",
    transform: "translate(-49.584 -62.792)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M67.922,91.745a.226.226,0,0,1-.07-.011L64.9,90.763a.224.224,0,0,1,.14-.426l2.955.971a.224.224,0,0,1-.07.437",
    transform: "translate(-48.809 -68.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M65.439,99.369a.226.226,0,0,1-.112-.03l-2.7-1.562a.224.224,0,0,1,.224-.388l2.7,1.562a.224.224,0,0,1-.112.418",
    transform: "translate(-47.128 -73.396)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M60.9,106.99a.223.223,0,0,1-.154-.061l-2.279-2.153a.224.224,0,1,1,.308-.326l2.279,2.153a.224.224,0,0,1-.154.387",
    transform: "translate(-44.024 -78.697)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M54.31,111.7a.224.224,0,0,1-.19-.1l-1.52-2.406a.224.224,0,1,1,.379-.239l1.52,2.406a.224.224,0,0,1-.189.344",
    transform: "translate(-39.628 -82.058)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M46.782,114.744a.224.224,0,0,1-.222-.195l-.338-2.533a.224.224,0,1,1,.444-.059L47,114.49a.224.224,0,0,1-.192.252l-.03,0",
    transform: "translate(-34.844 -84.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M85.742,35.9V57.51c0,.662.646,1.072,1.463,1.24V35.9Z",
    transform: "translate(-64.639 -27.063)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M86.518,58.288a.219.219,0,0,1-.046,0c-1.044-.216-1.642-.748-1.642-1.46V35.211a.224.224,0,0,1,.224-.224h1.464a.224.224,0,0,1,.224.224V58.064a.225.225,0,0,1-.224.224M85.278,35.435V56.823c0,.551.586.826,1.015.953V35.435Z",
    transform: "translate(-63.951 -26.376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M98.283,57.51V35.9H96.032V58.836c1.147-.04,2.251-.488,2.251-1.326",
    transform: "translate(-72.396 -27.063)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M95.345,58.373a.224.224,0,0,1-.224-.224V35.211a.224.224,0,0,1,.224-.224H97.6a.224.224,0,0,1,.224.224V56.823c0,1.011-1.239,1.507-2.468,1.55h-.008m.224-22.938V57.911c.907-.079,1.8-.435,1.8-1.087V35.435Z",
    transform: "translate(-71.71 -26.376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M91.687,35.9V58.75a4.559,4.559,0,0,0,1.069.085V35.9Z",
    transform: "translate(-69.121 -27.063)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M91.9,58.376a4.74,4.74,0,0,1-.946-.093.224.224,0,0,1-.179-.22V35.211A.224.224,0,0,1,91,34.987H92.07a.224.224,0,0,1,.224.224V58.149a.224.224,0,0,1-.216.224q-.088,0-.176,0m-.677-.5a4.387,4.387,0,0,0,.621.051V35.435h-.621Z",
    transform: "translate(-68.434 -26.376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M18.368.911a78.569,78.569,0,0,0,35.457,0L55.682,3.05c-12.645,3.62-25.761,3.283-39.228,0Z",
    transform: "translate(-12.404 -0.687)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M36.157,5.178h-.47a87.08,87.08,0,0,1-19.974-2.6.224.224,0,0,1-.114-.367L17.513.075a.224.224,0,0,1,.215-.07,78.754,78.754,0,0,0,35.357,0,.224.224,0,0,1,.222.071l1.857,2.139a.224.224,0,0,1-.108.363,68.619,68.619,0,0,1-18.9,2.6M16.183,2.233A86.377,86.377,0,0,0,35.69,4.728a68.28,68.28,0,0,0,18.9-2.484L53.057.474a79.193,79.193,0,0,1-35.3,0Z",
    transform: "translate(-11.717 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M22.1,10.933v1.013C34.585,14.8,46.76,15.093,58.534,12V10.989c-11.773,3.091-23.949,2.8-36.431-.056",
    transform: "translate(-16.663 -8.242)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M40.413,13.745l-.518,0a86.09,86.09,0,0,1-18.53-2.265.224.224,0,0,1-.174-.219V10.247a.224.224,0,0,1,.274-.219A85.63,85.63,0,0,0,39.9,12.282a68.58,68.58,0,0,0,17.891-2.2.224.224,0,0,1,.281.217v1.013a.224.224,0,0,1-.167.217,68.9,68.9,0,0,1-17.49,2.212M21.64,11.081A85.519,85.519,0,0,0,39.9,13.3a68.6,68.6,0,0,0,17.724-2.152v-.55A69.081,69.081,0,0,1,39.9,12.731a85.89,85.89,0,0,1-18.255-2.2Z",
    transform: "translate(-15.976 -7.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M26.287,16.1v.983c11.725,2.556,23.177,2.818,34.275.112v-.939c-10.986,2.6-22.468,2.387-34.275-.156",
    transform: "translate(-19.817 -12.14)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M43.58,18.642a84.655,84.655,0,0,1-18.028-2.023.224.224,0,0,1-.176-.219v-.983a.224.224,0,0,1,.271-.219c12.105,2.607,23.6,2.659,34.176.157a.224.224,0,0,1,.276.218v.939a.225.225,0,0,1-.171.218A68.88,68.88,0,0,1,43.58,18.642M25.824,16.219c12,2.593,23.383,2.632,33.827.116v-.479c-10.482,2.433-21.861,2.379-33.827-.162Z",
    transform: "translate(-19.13 -11.453)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M38.406,22.454v.991a75.255,75.255,0,0,0,28.239.179v-.959a77.027,77.027,0,0,1-28.239-.211",
    transform: "translate(-28.953 -16.928)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M52.723,24.4a82.694,82.694,0,0,1-15.044-1.426.224.224,0,0,1-.183-.221v-.991a.224.224,0,0,1,.265-.221,77.11,77.11,0,0,0,28.157.212.224.224,0,0,1,.266.221v.958a.224.224,0,0,1-.182.22A69.563,69.563,0,0,1,52.723,24.4M37.943,22.571a75.428,75.428,0,0,0,27.791.181v-.5a77.549,77.549,0,0,1-27.791-.213Z",
    transform: "translate(-28.267 -16.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M56.414,29.88V30.6H76.506v-.76a82.282,82.282,0,0,1-20.092.042",
    transform: "translate(-42.529 -22.494)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M75.82,30.136H55.727a.224.224,0,0,1-.224-.224v-.717a.224.224,0,0,1,.247-.223,81.5,81.5,0,0,0,20.037-.041.224.224,0,0,1,.257.222v.76a.224.224,0,0,1-.224.224M73.3,29.687h2.3v-.277q-1.127.159-2.3.277m-17.344,0h2.717q-1.333-.106-2.717-.245Z",
    transform: "translate(-41.843 -21.808)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M80.218,33.222a12.16,12.16,0,0,1-4.668-.78.224.224,0,0,1,.094-.428h9.149a.224.224,0,0,1,.094.428,12.16,12.16,0,0,1-4.668.78m-3.136-.76a15.945,15.945,0,0,0,6.271,0Z",
    transform: "translate(-56.857 -24.135)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_190",
    "data-name": "Rectangle 190",
    width: 4.854,
    height: 2.448,
    transform: "translate(20.976 1.519)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M89.394,8.156H84.54a.224.224,0,0,1-.224-.224V5.483a.224.224,0,0,1,.224-.224h4.854a.224.224,0,0,1,.224.224V7.932a.224.224,0,0,1-.224.224m-4.63-.448H89.17v-2H84.764Z",
    transform: "translate(-63.564 -3.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M89.735,3.073c0,.373-1.125.675-2.512.675s-2.511-.3-2.511-.675S85.837,2.4,87.223,2.4s2.512.3,2.512.675",
    transform: "translate(-63.863 -1.808)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M86.537,3.285c-1.016,0-2.736-.19-2.736-.9s1.72-.9,2.736-.9,2.736.19,2.736.9-1.72.9-2.736.9m-2.283-.9a3.9,3.9,0,0,0,2.283.451,3.9,3.9,0,0,0,2.284-.451,6,6,0,0,0-4.567,0m4.572.01h0Z",
    transform: "translate(-63.176 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M16.454,3.05l.035-.039,1.878-2.1,2.139.492L18.817,3.64Z",
    transform: "translate(-12.404 -0.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M18.13,3.178a.227.227,0,0,1-.054-.007l-2.364-.591a.224.224,0,0,1-.113-.367L17.512.075A.225.225,0,0,1,17.73.006L19.869.5A.224.224,0,0,1,20,.852L18.309,3.089a.225.225,0,0,1-.179.089m-1.949-.943L18.04,2.7,19.431.858,17.758.473Z",
    transform: "translate(-11.717 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M159.317,1.446l1.477,2.195,2.589-.591L161.526.911Z",
    transform: "translate(-120.106 -0.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M160.108,3.178a.224.224,0,0,1-.186-.1L158.444.884a.224.224,0,0,1,.133-.343l2.209-.535a.224.224,0,0,1,.222.071l1.857,2.139a.224.224,0,0,1-.119.366l-2.589.591a.228.228,0,0,1-.05.006M159,.9l1.211,1.8,2.074-.474L160.759.474Z",
    transform: "translate(-119.419 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M43.38,13.26s5.361-4.052,6.965-4.517c0,0-1.815,2.617-6.965,4.517",
    transform: "translate(-32.703 -6.591)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M83.855,13.835S92.2,8.343,94.7,7.714c0,0-2.827,3.546-10.848,6.121",
    transform: "translate(-63.216 -5.815)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCotranscat);
export default __webpack_public_path__ + "static/media/icon_cotranscat.5de16e9d489bd32dd609ddaa24ed03f3.svg";
export { ForwardRef as ReactComponent };